import React from 'react';

const FirebaseContext = React.createContext(null);

export const withFirebase = Component => props => (
    <FirebaseContext.Consumer>
        {firebase => <Component {...props} firebase={firebase}/>}
    </FirebaseContext.Consumer>
);

export const withAuth = Component => props => (
    <FirebaseContext.Consumer>
        {firebase => <Component {...props} auth={firebase.auth}/>}
    </FirebaseContext.Consumer>
);

export const withAuthenticated = Component => props => (
    <FirebaseContext.Consumer>
        {firebase => firebase.auth.tryGetCurrentUser()
            ? <Component {...props} auth={firebase.auth}/>
            : <div>NO NO NO SIR</div>}
    </FirebaseContext.Consumer>
);

export const withFirestore = Component => props => (
    <FirebaseContext.Consumer>
        {firebase => <Component {...props} firestore={firebase.firestore}/>}
    </FirebaseContext.Consumer>
);




export default FirebaseContext;
